import { ModelActionsModal } from '@models-global/model-actions';
import { IClaimAuditStatusUpdateParams } from '@module-claims/models/claim.interface';
import { ReportType } from '@module-report/enums/report-type.enum';

export class ActionClaimModalGenerateReport {
  static readonly type = '[Claim modal] generate report';
  constructor(public value: ReportType, public action: ModelActionsModal) {}
}

export class ActionClaimModalAuditStatusSave {
  static readonly type = '[Claim modal] audit status modal save';
  constructor(public params: IClaimAuditStatusUpdateParams) {}
}

export class ActionClaimModalAuditStatusClose {
  static readonly type = '[Claim modal] audit status modal close';
}
